import React, { useLayoutEffect, useRef, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import axios from "axios";
import countries from "i18n-iso-countries";
import "i18n-iso-countries/langs/en.json";
import Widget from "../../../../../components/Widget";

import style from "./PageVisits.module.scss";
am4core.useTheme(am4themes_animated);

const PageVisits = () => {
  const chartRef = useRef(null);
  const polygonRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    const chart = am4core.create("mapPageVisits", am4maps.MapChart);
    chartRef.current = chart;
    chart.geodata = am4geodata_worldLow;
    chart.projection = new am4maps.projections.Miller();
    // chart.contentHeight = 100;
    chart.homeZoomLevel = 3;
    // chart.homeGeoPoint = {
    //   longitude: 0,
    //   latitude: 0,
    // };

    chart.homeGeoPoint = {
      longitude: -40, // Midpoint between UAE (55°E) and USA (-95°W)
      latitude: 25, // Slightly north to align with both regions
    };

    const polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
    polygonRef.current = polygonSeries;
    polygonSeries.useGeodata = true;
    polygonSeries.tooltip.background.fill = am4core.color("#C7D0FF");
    polygonSeries.tooltip.getFillFromObject = false;
    polygonSeries.tooltip.label.fill = am4core.color("#495057");
    polygonSeries.tooltip.autoTextColor = false;

    chart.zoomControl = new am4maps.ZoomControl();
    chart.zoomControl.align = "left";
    chart.zoomControl.valign = "bottom";
    chart.zoomControl.dx = 2;
    chart.zoomControl.dy = -21;
    chart.zoomControl.layout = "horizontal";
    chart.zoomControl.minusButton.background.fill = am4core.color("C7D0FF");
    chart.zoomControl.plusButton.background.fill = am4core.color("C7D0FF");
    chart.zoomControl.minusButton.background.stroke = am4core.color("#6979C9");
    chart.zoomControl.plusButton.background.stroke = am4core.color("#6979C9");
    chart.zoomControl.plusButton.background.cornerRadius(3, 3, 3, 3);
    chart.zoomControl.minusButton.background.cornerRadius(3, 3, 3, 3);
    chart.zoomControl.plusButton.dx = 5;
    chart.zoomControl.plusButton.scale = 0.75;
    chart.zoomControl.minusButton.scale = 0.75;
    chart.zoomControl.plusButton.label.fill = am4core.color("#fff");
    chart.zoomControl.minusButton.label.fill = am4core.color("#fff");

    let plusButtonHoverState =
      chart.zoomControl.plusButton.background.states.create("hover");
    plusButtonHoverState.properties.fill = am4core.color("#020202");
    let minusButtonHoverState =
      chart.zoomControl.minusButton.background.states.create("hover");
    minusButtonHoverState.properties.fill = am4core.color("#020202");
    let polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.tooltipHTML = "{tooltip}";
    polygonTemplate.adapter.add("tooltipHTML", (html, target) => {
      const dataContext = target.dataItem?.dataContext;
      if (dataContext && dataContext.tooltip) {
        return html;
      }
      return null;
    });
    polygonTemplate.fill = am4core.color("#474D84");
    polygonTemplate.stroke = am4core.color("#6979C9");
    polygonTemplate.strokeWidth = 0.1;

    let hs = polygonTemplate.states.create("hover");
    hs.properties.fill = am4core.color("#354D84");

    // Add heat rule to dynamically assign colors based on the value
    polygonSeries.heatRules.push({
      property: "fill",
      target: polygonTemplate,
      min: am4core.color("#B8001F"), // Red for low values
      max: am4core.color("#B8001F"), // Green for high values
      dataField: "value",
    });

    countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

    fetchData();

    const interval = setInterval(fetchData, 60000);

    return () => {
      chart.dispose();
      clearInterval(interval);
    };
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://eadash.arabiansystems.com/api/Dashboard/FacebookAnalytics/PageVisits"
      );
      const data = response.data.data;

      let countryData = [];
      let countData = [];

      Object.entries(data)?.forEach(([countryItem, valueItem]) => {
        countryData?.push(countryItem);
        countData?.push(valueItem);
      });

      const fetchedActiveCountriesData = countryData?.map((item, id) => ({
        id: item,
        value: countData[id],
        tooltip: `<span style="font-weight:bold;">${getCountryName(
          item
        )}</span>`,
      }));

      if (polygonRef.current) {
        polygonRef.current.data = [];
        polygonRef.current.data = fetchedActiveCountriesData;
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getCountryName = (isoCode) => {
    return countries.getName(isoCode, "en") || "Unknown Country";
  };

  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-US").format(number);
  };

  return (
    <Widget>
      <div className={style.mapChart}>
        <div className={`w-100 visits ${style.stats}`}>
          <img
            src="/icons/location.png"
            width={window.innerWidth < 1576 ? "40" : "60"}
          />
          <div className="flexCol">
            <h6 style={{ color: "#f4f4f599", marginBottom: "0px" }}>
            User Base
            </h6>
            <div className="infoFlex">
              <i style={{ color: "#f4f4f599" }} class="fa fa-info-circle"></i>
              <p style={{ color: "#f4f4f599" }} className="m-0">
                Based on data from the last 30 days
              </p>
            </div>
          </div>
        </div>
        <div id="mapPageVisits" className={style.map}></div>
      </div>
    </Widget>
  );
};

export default PageVisits;
